<template>
  <div class="recommended-inner">
    <div
      v-if="!withoutDots"
      class="password-recommended mt-2 mb-4"
      :class="`password-recommended-${recommendedType}`"
    >
      <p class="password-recommended__text">{{ recommendedText }}</p>
      <div class="password-recommended__list" :class="recommendedType">
        <div
          v-for="index in 5"
          :key="index"
          class="password-recommended__item"
          :class="{ active: index <= recommendedPasswordCount }"
        ></div>
      </div>
    </div>
    <div v-if="!withoutList" class="recommended">
      <div class="recommended-title">הסיסמה צריכה לכלול</div>
      <ul class="recommended__list">
        <li
          :class="
            recommended.lengthText ? 'recommended-success' : 'recommended-error'
          "
        >
          <div
            class="recommended-icon"
            :class="recommended.lengthText ? 'success-icon' : 'error-icon'"
          >
            <icon
              v-if="recommended.lengthText"
              name="success"
              width="16"
              height="16"
            />
          </div>
          בין 8 ל- 20 תווים
        </li>
        <li
          :class="
            recommended.lowerCaseLetters
              ? 'recommended-success'
              : 'recommended-error'
          "
        >
          <div
            class="recommended-icon"
            :class="
              recommended.lowerCaseLetters ? 'success-icon' : 'error-icon'
            "
          >
            <icon
              v-if="recommended.lowerCaseLetters"
              name="success"
              width="16"
              height="16"
            />
          </div>
          לפחות אות אחת קטנה באנגלית (a-z)
        </li>
        <li
          :class="
            recommended.upperCaseLetters
              ? 'recommended-success'
              : 'recommended-error'
          "
        >
          <div
            class="recommended-icon"
            :class="
              recommended.upperCaseLetters ? 'success-icon' : 'error-icon'
            "
          >
            <icon
              v-if="recommended.upperCaseLetters"
              name="success"
              width="16"
              height="16"
            />
          </div>
          לפחות אות אחת גדולה באנגלית (A-Z)
        </li>
        <li
          :class="
            recommended.numbers ? 'recommended-success' : 'recommended-error'
          "
        >
          <div
            class="recommended-icon"
            :class="recommended.numbers ? 'success-icon' : 'error-icon'"
          >
            <icon
              v-if="recommended.numbers"
              name="success"
              width="16"
              height="16"
            />
          </div>
          ספרה אחת לפחות (0-9)
        </li>
        <li
          :class="
            recommended.symbols ? 'recommended-success' : 'recommended-error'
          "
        >
          <div
            class="recommended-icon"
            :class="recommended.symbols ? 'success-icon' : 'error-icon'"
          >
            <icon
              v-if="recommended.symbols"
              name="success"
              width="16"
              height="16"
            />
          </div>
          תו אחד מיוחד לפחות (!@#$%^&*()-+/\{})
        </li>
      </ul>
      <template v-if="$route.name !== 'FirstChangePassword'">
        <div class="recommended-title">שימו לב</div>
        <ul class="recommended__list">
          <li
            :class="
              recommended.passwordError
                ? 'recommended-warning'
                : 'recommended-success'
            "
          >
            <div
              class="recommended-icon"
              :class="
                recommended.passwordError ? 'warning-icon' : 'success-icon'
              "
            >
              <icon
                v-if="recommended.passwordError"
                name="warning"
                width="2"
                height="7"
              />
              <icon v-else name="success" width="16" height="16" />
            </div>
            לא להשתמש בסיסמה שהשתמשת בה בעבר
          </li>
          <li class="recommended-success">
            <div class="recommended-icon success-icon">
              <icon name="success" width="16" height="16" />
            </div>
            לא להשתמש במספר ת.ז., נייד ,תאריך לידה
          </li>
          <li class="recommended-success">
            <div class="recommended-icon success-icon">
              <icon name="success" width="16" height="16" />
            </div>
            לא לחזור על תו יותר מפעמיים ברציפות
          </li>
        </ul>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecommendedPassword',
  props: {
    recommended: {
      type: Object,
      required: true
    },
    recommendedPasswordCount: {
      type: Number,
      default: 0
    },
    recommendedText: {
      type: String,
      default: 'error'
    },
    recommendedType: {
      type: String,
      default: 'error'
    },
    withoutList: {
      type: Boolean,
      default: false
    },
    withoutDots: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style>
.entry-block__form {
  max-width: 310px;
}
</style>
